import { useCallback } from "react";
import { isInternalUrl } from "../util";
import useFixaNavigate from "@coworker/apprestructured/src/shared/wrappers/FixaNavigate/useFixaNavigate";
import { getByPath } from "@coworker/apprestructured/src/shared/helpers/object.helper";

const formatUrl = (url: string, context?: Record<string, unknown>): string => {
  if (!context) return url;
  return url.replace(/\{([^}]+)\}/g, (_, expression: string) => {
    const paths = expression.split("||");
    for (const path of paths) {
      try {
        const value = getByPath(context, path.trim());
        if (value !== undefined && value !== "") return String(value);
      } catch {
        console.warn(`Path "${path.trim()}" not found in context`);
      }
    }
    return "";
  });
};

export const useRedirect = () => {
  const navigate = useFixaNavigate();

  const redirect = useCallback(
    (url: string, openNewTab: boolean, context?: Record<string, unknown>) => {
      if (typeof window === "undefined") {
        return;
      }

      const formattedUrl = formatUrl(url, context);

      if (openNewTab) {
        const newWindow = window.open(
          formattedUrl,
          "_blank",
          "noopener,noreferrer"
        );
        if (newWindow) {
          newWindow.opener = null;
        }
      } else if (isInternalUrl(formattedUrl)) {
        const parsedUrl = new URL(formattedUrl, window.location.href);
        navigate(`${parsedUrl.pathname}${parsedUrl.search}${parsedUrl.hash}`);
      } else {
        setTimeout(() => {
          window.location.href = formattedUrl;
        }, 0);
      }
    },
    [navigate]
  );

  return redirect;
};
